'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var ActionBarComponent = /** @class */ (function () {
    function ActionBarComponent() {
    }
    return ActionBarComponent;
}());
exports.ActionBarComponent = ActionBarComponent;
